// Overview hooks — React Query wrapper for the overview data layer.

import { useQuery } from "@tanstack/react-query";
import { getOverview } from "./api";

/** Fetch and cache the platform overview KPIs. Query key: ["overview"]. */
export function useOverview() {
  return useQuery({ queryKey: ["overview"], queryFn: getOverview });
}
